@if (!loading) {
  <svg-icon
    class="button-icon min-w-auto max-w-none min-h-auto max-h-none pointer-events-none"
    preserveAspectRatio="none"
    [ngClass]="{
      'w-2.5 h-2.5': iconSize === 'basic',
      'w-4 h-4 w-max-4 h-max-4': iconSize === 'tiny',
      'w-5 h-5': iconSize === 'small',
      'w-6 h-6': iconSize === 'large',
    }"
    [src]="svgIconPath"
    [stretch]="true"
  ></svg-icon>
} @else {
  <app-circle-loader [appearance]="loaderAppearance"></app-circle-loader>
}
